import maplibregl from 'maplibre-gl';
import React, { FunctionComponent, memo } from 'react';

import { HTML_ELEMENTS } from '@/constants/constants';

import ToolKit from './toolkit';

interface Props {
  map: maplibregl.Map | undefined;
}

/** Includes the map nav, map settings, and the edit land selections footer */
const BottomNavigation: FunctionComponent<Props> = ({ map }) => (
  <div className="flex w-full flex-col transition-all">
    <div
      className="visible flex w-fit items-end gap-x-4 pb-4 pl-5"
      id={HTML_ELEMENTS.BOTTOM_NAV_CONTAINER}
    >
      <ToolKit map={map} />
    </div>
  </div>
);

export default memo(BottomNavigation);
